import { FormNewFormState, StepsFormState } from '..';
import {
  DesignType,
  InputType,
  ViewType,
} from '../../../services/api/types/steps';

export const HVACWizardTemplate: {
  formF: FormNewFormState;
  stepsF: StepsFormState;
} = {
  formF: {
    name: 'Example HVAC Form',
    slug: 'example-hvac-form',
    brandColor: '189ED9',
    origin: 'https://example.com/',
    widgetTitle: 'Get estimate for free',
    widgetButtonText: 'Start estimation',
    logoImageId: null as any,
    developmentMode: false,
    createDefaultPopup: true,
    requirePhone: true,
    requireAdditionalNotes: true,
    requireAddress: true,
    linkable: true,
    resultScreenButtonRedirect: null,
    resultScreenRedirect: null,
  },
  stepsF: {
    steps: [
      {
        title: 'What services are you looking for?',
        order: 0,
        isFinalStep: false,
        submitButtonText: 'Continue',
        type: InputType.SINGLE_SELECT,
        designType: DesignType.CARDS,
        viewType: ViewType.GRID,
        nextQuestionIndex: 1,
        dataAnnotation: null,
        options: [
          {
            value: 'New Installation',
            resultTitle: 'New Installation Result Title',
            resultDescription: 'New Installation Result Description',
            order: 0,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Repair',
            resultTitle: 'Repair Result Title',
            resultDescription: 'Repair Result Description',
            order: 1,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Servicing',
            resultTitle: 'Servicing Result Title',
            resultDescription: 'Servicing Result Description',
            order: 2,
            imageId: null as any,
            nextQuestionIndex: null,
          },
        ],
      },
      {
        title: 'How many air conditioning units do you have on your property?',
        order: 1,
        isFinalStep: false,
        submitButtonText: 'Continue',
        type: InputType.SINGLE_SELECT,
        designType: DesignType.CARDS,
        viewType: ViewType.GRID,
        nextQuestionIndex: 2,
        dataAnnotation: null,
        options: [
          {
            value: 'One',
            order: 0,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Two',
            order: 1,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Three',
            order: 2,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Four or more',
            order: 3,
            imageId: null as any,
            nextQuestionIndex: null,
          },
        ],
      },
      {
        title: 'Which floor is our service required on?',
        order: 2,
        isFinalStep: false,
        submitButtonText: 'Continue',
        type: InputType.SINGLE_SELECT,
        designType: DesignType.CARDS,
        viewType: ViewType.GRID,
        nextQuestionIndex: 3,
        dataAnnotation: null,
        options: [
          {
            value: 'Basement',
            order: 0,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'First floor',
            order: 1,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Second floor',
            order: 2,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Third floor or up',
            order: 3,
            imageId: null as any,
            nextQuestionIndex: null,
          },
        ],
      },
      {
        title: 'When would you like this service to be done?',
        order: 3,
        isFinalStep: false,
        submitButtonText: 'Continue',
        type: InputType.SINGLE_SELECT,
        designType: DesignType.CARDS,
        viewType: ViewType.GRID,
        nextQuestionIndex: 4,
        dataAnnotation: null,
        options: [
          {
            value: 'As soon as possible',
            order: 0,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: `I'm flexible`,
            order: 1,
            imageId: null as any,
            nextQuestionIndex: null,
          },
          {
            value: 'Planning and budgeting for future',
            order: 2,
            imageId: null as any,
            nextQuestionIndex: null,
          },
        ],
      },
      {
        title:
          'Alright, you are one step away from your free instant estimate!',
        order: 4,
        isFinalStep: true,
        submitButtonText: 'Submit For An Estimation',
        type: null,
        designType: DesignType.CARDS,
        viewType: ViewType.GRID,
        options: undefined as any,
        nextQuestionIndex: null,
        dataAnnotation: null,
      },
    ],
  },
};
